import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    theme: 'white',
    loaded: false,
    lang: null,
    user: {},
    search: {
      user: null
    }
  },
  mutations: {
    setTheme(state, theme) {
      if(theme == 'dark') {
        document.documentElement.classList.add('dark')
      } else {
        document.documentElement.classList.remove('dark')
      }
      state.theme = theme
    },
    setLoaded(state, loaded) {
      state.loaded = loaded
    },
    setUser(state, data) {
      if(data && ('auth' in data)) {
        state.user = data
      } else {
        state.user = {}
      }
    }
  }
})